import * as s from "../LoginStyled";
import { UnderlineText } from "components/atoms/text/Text";
import { COLORS } from "styles/colors";
import { LOGIN_STEP, LoginInfo } from "../LoginContainer";

interface Props {
  loginInfo: LoginInfo;
  onChangeStep: (step: LOGIN_STEP) => void;
}

export default function ForgotPasswordSent({ loginInfo, onChangeStep }: Props) {
  return (
    <>
      <s.InputWrapper>
        <s.LoginInfo>
          <h3>FORGOT PASSWORD</h3>
          <p className="description">
            We've sent an email to <strong>{loginInfo.email}</strong>, please
            follow the link in the email to reset your password.
          </p>
        </s.LoginInfo>
        <s.Bottom center>
          <UnderlineText
            id="dw_login_button_forward_password"
            fontSize={14}
            color={COLORS.BUTTONS1}
            onClick={() => onChangeStep(LOGIN_STEP.INPUT_PASSWORD)}
            data-testid="auth-signin-forgot-forward-password-change-step"
          >
            Go Back
          </UnderlineText>
        </s.Bottom>
      </s.InputWrapper>
    </>
  );
}
